module.exports = __webpack_public_path__ + "img/empty.13463182.png";